export const MAX_ITERATIONS_IN_CHARTS = 5

export const STORY_TYPE_CHART_COLORS = {
  Feature: '#6091B5',
  Design: '#CDE7FF',
  Chore: '#E1F6F1',
  Bug: '#FBC7B3',
}
export const STORY_TYPE_CHART_ACTIVE_COLORS = {
  Feature: '#4E7391',
  Design: '#8CC7FF',
  Chore: '#ABF4DF',
  Bug: '#F8A688',
}

export const LINE_CHART_STROKE_COLOR = '#10A9FF'

export const CHART_GRID_BORDER_COLOR = '#E2E8F0'
export const CHART_CURSOR_STROKE_COLOR = '#456580'
export const CHART_BAR_COLOR = '#EFEFEF'

export const CHART_X_AXIS_TICK_LABEL_COLOR = '#283139'
export const CHART_Y_AXIS_TICK_LABEL_COLOR = '#6091B5'

export const CHART_DOT_ACTIVE_COLOR = '#304151'

export const CHART_GRID_VERTICAL_BAND_COLOR_1 = '#F8F8F8'
export const CHART_GRID_VERTICAL_BAND_COLOR_2 = '#FFFFFF'
